/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { IconChevronLeft } from "@tabler/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchOutletSingleStaff } from "../../apis/staffApis";
import formatDate from "../../utilities/helper";

export default function ViewStaffDetails() {
  const { id } = useParams();
  const { data: staffDetails, refetch: fetchStaffDetails } =
    useFetchOutletSingleStaff(id);

  useEffect(() => {
    if (id) {
      fetchStaffDetails();
    }
  }, [id]);

  const Section = ({
    title,
    children,
  }: {
    title?: string;
    children: React.ReactNode;
  }) => (
    <div className="p-4 bg-[#F7F6F2] rounded-3xl border border-[#EFEFEF] space-y-2">
      <div className="grid grid-cols-1 gap-x-6 ">{children}</div>
    </div>
  );

  const TwoCol = ({
    label,
    value,
  }: {
    label: string;
    value: React.ReactNode;
  }) => (
    <div className="text-sm text-[#1E293B] flex justify-between items-center gap-1 border-b py-3 last:border-0 px-4 ">
      <p className=" text-[#212121] capitalize">{label}:</p>
      <p className="font-medium"> {value}</p>
    </div>
  );

  const navigate = useNavigate();

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        {/* Header */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
            >
              <IconChevronLeft strokeWidth={1.5} size={22} />
            </button>
            <div className="flex items-center gap-2">
              <img
                src={staffDetails?.photo || "/img/dummy-blank-profile.png"}
                className="size-10 rounded-full  outline-[0.5px] object-cover "
                alt=""
              />
              <h1 className="text-2xl text-[#212121] tracking-[-0.5px]  ">
                {staffDetails?.name}
              </h1>
            </div>
          </div>
        </div>

        <div className="">
          <div className="grid grid-cols-1 gap-6">
            <Section title={""}>
              <div className="pb-4">
                <h3 className="text-[#212121] font-medium text-lg ">
                  Staff Details{" "}
                </h3>
              </div>
              <div className="bg-[#FCFDF8] border rounded-2xl overflow-hidden">
                <h3 className="text-[#212121] font-medium text-base capitalize border-b border-gray-300 border-dashed py-2 w-full bg-[#F7F6F2] rounded-t-xl px-4">
                  Personal Details{" "}
                </h3>
                <TwoCol label="Name" value={staffDetails?.name} />
                <TwoCol label="Mobile Number" value={staffDetails?.phone} />
                <TwoCol label="Email" value={staffDetails?.email} />
                <TwoCol label="Country" value={staffDetails?.country} />
                <TwoCol label="City" value={staffDetails?.city} />
                <TwoCol label="District" value={staffDetails?.district} />
                <TwoCol
                  label="Assigned Outlet"
                  value={staffDetails?.outletList?.[0]?.name || "—"}
                />
                <TwoCol label="Role" value={staffDetails?.roleName} />
                <TwoCol
                  label="Start Date"
                  value={formatDate(staffDetails?.startDate)}
                />
                <TwoCol label="Iqama Number" value={staffDetails?.iqamaNo} />
                <TwoCol label="Address" value={staffDetails?.address} />
                <TwoCol
                  label="Short Address"
                  value={staffDetails?.shortAddress}
                />
                {staffDetails?.darkStoreName && (
                  <TwoCol
                    label="Dark Store"
                    value={staffDetails?.darkStoreName}
                  />
                )}
              </div>
            </Section>
          </div>
        </div>
      </div>
    </>
  );
}
